import { useMutation } from '@tanstack/react-query';
import { jobsApi } from '../api/jobsApi';

/**
 * Hook for triggering pot status transitions job
 */
export const useTriggerPotStatusTransitions = () => {
  return useMutation({
    mutationFn: jobsApi.triggerPotStatusTransitions,
  });
};

/**
 * Hook for triggering notification definition processing
 */
export const useProcessNotificationDefinitions = () => {
  return useMutation({
    mutationFn: jobsApi.processNotificationDefinitions,
  });
};

/**
 * Hook for triggering push notification dispatching
 */
export const useProcessPushNotifications = () => {
  return useMutation({
    mutationFn: jobsApi.processPushNotifications,
  });
};

/**
 * Hook for triggering invoice generation job
 */
export const useTriggerInvoiceGeneration = () => {
  return useMutation({
    mutationFn: jobsApi.triggerInvoiceGeneration,
  });
};
